import React from "react";
import _ from "lodash";
import numeral from "numeral";
import styled, { css } from "styled-components";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import IconClose from "@material-ui/icons/Close";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";

import StatItem from "../StatItem";

import { H3 } from "../Typography";

import {
  getProjectStat,
  calculateAvgProjectStats,
} from "../../utils/stat-utils";
import { checkRole } from '../../utils/checkRole';

const Container = styled.div`
  ${(props) =>
    props.layout === "B" &&
    `
    position: absolute;
    bottom: -80px;
    left: 0;
    right: 0;
    height: 80px;
    background: white;
  `};
`;

const StatRow = connect((state) => ({
  layout: state.domain.design.layout,
  overviewPosition: state.domain.design.overviewPosition,
}))(styled.div`
  display: flex;
  ${(props) =>
    props.layout === "A" &&
    css`
      flex-direction: column;

      @media (min-width: 768px) {
        flex-direction: row;
      }
    `}

  ${(props) =>
    props.layout === "B" &&
    css`
      flex-direction: column;

      @media (min-width: 768px) {
        flex-direction: column;
      }
    `}

  ${(props) =>
    props.overviewPosition === "B" &&
    css`
      flex-direction: row;
      @media (min-width: 768px) {
        flex-direction: row;
      }
    `}
`);

const SkyDronButton = styled.div`
  flex: 1;
  text-align: center;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  background: #fff;
`;

const SkyDronButtonBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #eb6323;
  padding: 10px 20px;
  flex-grow: 0;
  border: 2px solid #eb6323;
  cursor: pointer;
`;

const SkyDronButtonModal = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 80vw;
  &:focus {
    outline: none;
  }
  > * {
    &:focus {
      outline: none;
    }
  }
`;

const CloseModal = styled.div`
  width: 30px;
  height: 30px;
  border: 2px solid #eb6323;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eee;
  position: absolute;
  right: -15px;
  top: -15px;
  z-index: 3;
  cursor: pointer;
`;

const RowHeading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Label = styled.div``;

export default class extends React.PureComponent {
  static defaultProps = {
    projects: [],
    area: "",
  };

  state = {
    skydronModal: false,
    openPopover: false,
    checked: [true, true, true, true, true, true, true],
  };

  openPopover = (e) => {
    this.setState({
      openPopover: true,
    });
  };

  handleClosePopover = (e) => {
    this.setState({
      openPopover: false,
    });
  };

  handleOpenSykDrone = () => {
    this.setState({ skydronModal: true });
  };

  handleCloseSykDrone = () => {
    console.log("handleCloseSykDrone");
    this.setState({ skydronModal: false });
  };

  sanitizeKeyValues = (key, values) => {
    return _.map(
      _.filter(values, (value) => {
        // console.log('sanitizeKeyValues', key, value, value[key])
        if (value[key] === "N/A") return false;
        if (value[key] === 0) return false;
        if (_.isNaN(value[key])) return false;
        if (value[key] === Infinity) return false;
        return true;
      }),
      key
    );
  };

  handleToggle = (index) => {
    const oldIndexShow = this.state.checked[index];
    const checkedData = this.state.checked;

    const sizeShow = _.chain(this.state.checked)
      .filter((check) => check === true)
      .size()
      .value();

    if (sizeShow < 7) {
      checkedData[index] = !oldIndexShow;
      this.setState(
        {
          checked: checkedData,
        },
        () => this.forceUpdate()
      );
    } else if (sizeShow === 7 && oldIndexShow === true) {
      checkedData[index] = false;
      this.setState(
        {
          checked: checkedData,
        },
        () => this.forceUpdate()
      );
    }
  };

  render() {
    const { layout, pointOfInterest, projects, userRoles } = this.props;
    const locationType = _.get(pointOfInterest, "type");
    const locationId = _.get(pointOfInterest, "id", "");
    const locationSkydroneVideo = _.get(
      pointOfInterest,
      "skydrone_video",
      false
    );
    // console.log('overview projects ?? ', projects);

    const allProjectStats = _.map(projects, getProjectStat);
    // console.log("overview allProjectStats ?? ", allProjectStats);

    const avg = calculateAvgProjectStats(allProjectStats, true);
    // console.log("overview avg ?? ", avg);

    // console.log('allProjectStats', { allProjectStats })

    // const capitalGainValues = this.sanitizeKeyValues('capitalGain', allProjectStats)
    // const rentalPriceValues = this.sanitizeKeyValues('rentalPrice', allProjectStats)
    // const rentalYieldValues = this.sanitizeKeyValues('rentalYield', allProjectStats)
    // const salePriceValues = this.sanitizeKeyValues('salePrice', allProjectStats)
    // const startingPriceValues = this.sanitizeKeyValues('startingPrice', allProjectStats)

    // console.log('allProjectStats', {
    //   capitalGainValues,
    //   rentalPriceValues,
    //   rentalYieldValues,
    //   salePriceValues,
    //   startingPriceValues
    // })

    // const avg = {
    //   salePrice: _.sum(salePriceValues) / _.size(salePriceValues),
    //   capitalGain: _.sum(capitalGainValues) / _.size(capitalGainValues),
    //   startingPrice: _.sum(startingPriceValues) / _.size(startingPriceValues),
    //   rentalPrice: _.sum(rentalPriceValues) / _.size(rentalPriceValues),
    //   rentalYield: _.sum(rentalYieldValues) / _.size(rentalYieldValues)
    // };
    // console.log("avg??", { avg });

    const textAvg = {
      salePrice: _.isNumber(avg.resalePriceSqm)
        ? `${numeral(avg.resalePriceSqm).format("0,0a")}`
        : "N/A",
      capitalGain: _.isNumber(avg.capitalGain)
        ? numeral(avg.capitalGain).format("0.00")
        : "N/A",
      startingPrice: _.isNumber(avg.startingPrice)
        ? `${numeral(avg.startingPrice).format("0.00a")}`
        : "N/A",
      rentalPrice: _.isNumber(avg.rentalPriceSqm)
        ? `${numeral(avg.rentalPriceSqm).format("0,0.00")}`
        : "N/A",
      rentalYield: _.isNumber(avg.rentalYield)
        ? numeral(avg.rentalYield).format("0.00")
        : "N/A",
      percentSold: _.isNumber(avg.percentSold)
        ? numeral(avg.percentSold).format("0.00")
        : "N/A",
      unitsLeft: _.isNumber(avg.unitsLeft)
        ? numeral(avg.unitsLeft).format("0")
        : "N/A",
      // salePrice: avg.salePrice === 0 ? 'N/A' : `${numeral(avg.salePrice).format("0,0a")}`,
      // capitalGain: avg.capitalGain === 0 ? 'N/A' : numeral(avg.capitalGain).format("0.00%"),
      // startingPrice: avg.startingPrice === 0 ? 'N/A' : `${numeral(avg.startingPrice).format("0.00a")}`,
      // rentalPrice: avg.rentalPrice === 0 ? 'N/A' : `${numeral(avg.rentalPrice).format("0,0.00")}`,
      // rentalYield: avg.rentalYield === 0 ? 'N/A' : numeral(avg.rentalYield).format("0.00%"),
      // percentSold: avg.percentSold === 0 ? 'N/A' : numeral(avg.percentSold).format("0.00%"),
      // unitsLeft: avg.unitsLeft === 0 ? 'N/A' : numeral(avg.unitsLeft).format("0"),
    };

    let settingAvgData = [
      {
        id: 0,
        title: "Sale Price/Sq.m.",
        value: textAvg.salePrice,
      },
      {
        id: 1,
        title: "Capital Gain",
        value: textAvg.capitalGain,
        suffix: "%",
      },
      {
        id: 2,
        title: "Starting Price",
        value: textAvg.startingPrice,
      },
      {
        id: 3,
        title: "Rent Price/Sq.m.",
        value: textAvg.rentalPrice,
      },
      {
        id: 4,
        title: "Rental Yield",
        value: textAvg.rentalYield,
        suffix: "%",
      },
    ];

    if (!checkRole(userRoles, 'mi-treasure.general-member')) {
      settingAvgData.push({
        id: 5,
        title: "%Sold",
        value: textAvg.percentSold,
        suffix: "%",
      });
      settingAvgData.push({
        id: 6,
        title: "Sum Units Left",
        value: textAvg.unitsLeft,
      });
    }
    // console.log('textAvg', { textAvg })
    return (
      <Container layout={layout}>
        <div>
          <Card>
            <CardContent style={layout === "B" ? { padding: "4px 12px" } : {}}>
              {/* <Typography style={{ textAlign: 'center' }}>{_.get(pointOfInterest, 'title.en', `${_.get(pointOfInterest, 'position.location._lat')}, ${_.get(pointOfInterest, 'position.location._long')}`)}</Typography> */}
              <StatRow>
                <RowHeading>
                  <h1 style={{ fontSize: "1.2rem", margin: 0 }}>Avg. Data</h1>
                  <h1 style={{ fontSize: "1.2rem", margin: 0 }}>in Area</h1>
                </RowHeading>
                {_.map(settingAvgData, (data, i) => {
                  const isShow = this.state.checked[i];
                  return (
                    isShow && (
                      <StatItem
                        key={`state-${i}`}
                        label={_.get(data, "title")}
                        value={_.get(data, "value")}
                        suffix={_.get(data, "suffix", "")}
                      />
                    )
                  );
                })}
                <div
                  style={{
                    width: 100,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 10,
                  }}
                >
                  <Button
                    buttonRef={(c) => (this.anchorEl = c)}
                    onClick={this.openPopover}
                    style={{
                      fontSize: "0.8rem",
                      whiteSpace: "nowrap",
                      border: "1px solid #eb6323",
                      color: "#eb6323",
                    }}
                  >
                    Setting
                  </Button>
                </div>
              </StatRow>
            </CardContent>
          </Card>
        </div>
        <Paper elevation={12} style={{ background: "white", display: "flex" }}>
          <Popover
            open={this.state.openPopover}
            anchorEl={this.anchorEl}
            onClose={this.handleClosePopover}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <List
              component="div"
              disablePadding
              dense
              style={{ background: "#f7f7f7" }}
            >
              {_.map(settingAvgData, (data, i) => {
                const isShow = this.state.checked[i];

                return (
                  <ListItem
                    button
                    key={i}
                    style={{ paddingTop: 8, paddingBottom: 8 }}
                    onClick={() => this.handleToggle(i)}
                  >
                    <Checkbox checked={isShow} tabIndex={-1} disableRipple />
                    <ListItemText
                      primary={_.get(data, "title")}
                      style={{ fontSize: 12 }}
                    />
                  </ListItem>
                );
              })}
            </List>
          </Popover>
        </Paper>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.skydronModal}
          onClose={this.handleCloseSykDrone}
        >
          <SkyDronButtonModal>
            <CloseModal onClick={this.handleCloseSykDrone}>
              <IconClose color="error" />
            </CloseModal>
            <video width="100%" controls src={locationSkydroneVideo} />
          </SkyDronButtonModal>
        </Modal>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SummaryContainer/Overview.js